<template>
	<v-container grid-list-xl>
		<v-form
			ref="rename"
			v-model="valid"
			@submit.prevent="updateKeywordList()"
		>
			<v-layout
				row
				wrap
				ma-0
				justify-center
				align-center
			>
				<v-flex
					xs12
					sm9
					py-0
					class="text-xs-left"
				>
					<v-text-field
						v-model="newName"
						:rules="[validateCheckDuplicates(newName, existingNames),
							...validate.require, validate.max(newName, 35)]"
						autofocus
						name="name"
						label="New Name"
					/>
					<v-checkbox
						v-model="newWholeWordsOnly"
						label="Match Whole Words Only"
						hide-details
					/>
					<v-checkbox
						v-model="newCaseSensitive"
						label="Case Sensitive"
						hide-details
					/>
				</v-flex>
				<v-flex
					sm3
					md2
					class="text-xs-center"
				>
					<v-btn
						:disabled="!valid"
						color="primary"
						type="submit"
					>
						Submit
					</v-btn>
					<v-btn
						flat
						color="error"
						@click="$emit('close')"
					>
						close
					</v-btn>
				</v-flex>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
import Validation from '@/mixins/Validation';

export default {
	props: {
		listName: { type: String, default: '' },
		existingNames: { type: Array, default: () => [] },
		wholeWordsOnly: { type: Boolean, default: false },
		caseSensitive: { type: Boolean, default: false },
	},
	mixins: [Validation],
	data() {
		return {
			valid: true,
			newName: '',
			newWholeWordsOnly: false,
			newCaseSensitive: false,
		};
	},
	created() {
		this.newName = this.listName;
		this.newWholeWordsOnly = this.wholeWordsOnly;
		this.newCaseSensitive = this.caseSensitive;
	},
	methods: {
		updateKeywordList() {
			this.$emit('update-name', {
				name: this.newName,
				wholeWordsOnly: this.newWholeWordsOnly,
				caseSensitive: this.newCaseSensitive,
			});
		},
	},
};
</script>
